import PlusCircleFill from "~icons/eva/plus-circle-fill"
import EditFill from "~icons/eva/edit-fill"
import { _t } from "@cruisen/i18n"
import { TripRoomCreatedNotificationData, TripRoomRenamesNotificationData } from "@cruisen/contract"
import styles from "./styles.module.scss"

export const TripRoomsChanged = ({
  data,
  created,
}: {
  data: TripRoomCreatedNotificationData | TripRoomRenamesNotificationData
  created: boolean
  iconName: string
}) => (
  <div
    className={styles.container}
    //testID={`navigator-message-room-${created ? "created" : "renamed"}`}
  >
    {created ? <PlusCircleFill className={styles.icon} /> : <EditFill className={styles.icon} />}
    <p>
      {created
        ? _t("notifications.tripRoomCreated.body", data)
        : _t("notifications.tripRoomRenamed.body", data)}
    </p>
  </div>
)
